var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ExprTag } from '@easyquery/core';
import { createBrowserEvent } from '@easydata/ui';
import { ColumnRendererCB } from './column_renderer_cb';
var SimpleColumnRendererCB = /** @class */ (function (_super) {
    __extends(SimpleColumnRendererCB, _super);
    function SimpleColumnRendererCB() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleColumnRendererCB.prototype.getClassesToAdd = function () {
        return _super.prototype.getClassesToAdd.call(this) + " " + this.cssPrefix + "-row " + this.cssPrefix + "-row-column-entattr";
    };
    SimpleColumnRendererCB.prototype.baseExpressionItemSelectedCallback = function (data, item) {
        var attrid = data.id;
        //this.column.expr.id = attrid;
        this.column.expr.setValue(attrid, true);
        this.column.caption = '';
        this.refresh();
        this.fireColumnChanged();
    };
    SimpleColumnRendererCB.prototype.getUIS = function () {
        var arg = this.column.expr.args[0];
        if (arg) {
            var model = this.bar.getContext().getModel();
            return model.checkAttrProperty(arg.value, "useInSorting");
        }
        else {
            return true;
        }
    };
    SimpleColumnRendererCB.prototype.changeTypeToCustomSql = function () {
        var query = this.column.getQuery();
        query.changeColumnType(this.column, ExprTag.CustomSql);
        this.fireColumnChanged();
    };
    SimpleColumnRendererCB.prototype.changeTypeToAggr = function (funcId) {
        var query = this.column.getQuery();
        query.changeColumnType(this.column, ExprTag.AggregateFunction, { funcId: funcId });
        this.fireColumnChanged();
    };
    SimpleColumnRendererCB.prototype.changeColumnTypeHandler = function (ev) {
        var _this = this;
        this.functionMenu.showMenu({
            anchor: ev.target,
            selectedIds: null,
            itemSelectedCallback: function (data, items) {
                if (data.id == "CUSTOMSQL") {
                    _this.changeTypeToCustomSql();
                }
                else {
                    _this.changeTypeToAggr(data.id);
                }
                return false;
            },
            menuClosedCallback: function () {
                _this.keepShowingButtons = false;
                if (!_this.isMouseOverBlock) {
                    _this.element.dispatchEvent(createBrowserEvent('mouseleave'));
                }
            }
        });
    };
    return SimpleColumnRendererCB;
}(ColumnRendererCB));
export { SimpleColumnRendererCB };
//# sourceMappingURL=simple_column_renderer.js.map